import type { ReactNode } from 'react';

interface ScreenHeaderProps {
  title: string;
  subtitle?: string;
  right?: ReactNode;
}

export function ScreenHeader({ title, subtitle, right }: ScreenHeaderProps) {
  return (
    <header className="screen-header">
      <div className="spread">
        <div>
          <h1 className="text-display">{title}</h1>
          {subtitle ? <p className="muted">{subtitle}</p> : null}
        </div>
        {right}
      </div>
    </header>
  );
}
